import type { CheckoutBasketModelsSubscriptionInfoViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'modules/helpers/strings';
import { DeliveryHereafter } from 'autogen/translation-keys/trans-website-basket-subscription';

export default function SubscriptionFrequencyInfo({
    model: { subscriptionFrequencyInfo }
}: {
    model: CheckoutBasketModelsSubscriptionInfoViewModel;
}) {
    const { t } = useTranslation();
    const { selected, isReadOnly } = subscriptionFrequencyInfo;

    if (isReadOnly) {
        return (
            <Typography.Body
                as="span"
                size="S"
                // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
                dangerouslySetInnerHTML={{
                    __html: format(t(DeliveryHereafter))(selected?.name, selected?.nextDeliveryWeekNumber)
                }}
            />
        );
    }

    return null;
}
